import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FacetCommon from './FacetForm'

const FacetEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <FacetCommon toolbar={<WithDeleteModalToolbar />} disable />
      </Edit>
    </SectionWrapper>
  )
}

export default FacetEdit
